import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import emptyCart from '../Layout/imgs/Empty_Cart.png';
import './CartEmpty.css';

const CartEmpty = ({ infoSource, sectionProps = {}, emptyText }) => {
    const text = infoSource?.laguangeElakay?.('text', infoSource?.languageAPI);
    const labels = infoSource?.laguangeElakay?.('frontElakayHardcodedText', infoSource?.languageAPI)?.cart;

    return (
        <section className="cart-empty" aria-labelledby="cart-empty-title">
            <div className="cart-empty-illustration" aria-hidden="true">
                <img src={emptyCart} alt="" width="1366" height="768" className="cart-empty-image" />
            </div>
            <h1 id="cart-empty-title" className="cart-empty-title">
                {sectionProps.emptyText || emptyText || text?.emptyCart || 'Your cart is empty'}
            </h1>
            <p className="cart-empty-text">
                {labels?.emptyDescription || 'Your next favorite find is waiting. Explore our products and add what you love to your cart.'}
            </p>
            <Link to="/new-product" className="cart-empty-action">
                {labels?.discoverProducts || 'Discover products'}
                <FiArrowRight aria-hidden="true" />
            </Link>
        </section>
    );
};

export default CartEmpty;
